import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import styles from '../VolunteeringFiltersModal.module.scss'
import { FilterProps } from '../VolunteeringFiltersModal.types'

import { OpportunityType } from '@percent/workplace-giving/api/opportunity/dto'
import { Box, Flex, Typography } from '@percent/lemonade'
import { Chip } from '@percent/workplace-giving/common/components/Chip/Chip'

export function OpportunityTypeFilter({ selectedFilters, setSelectedFilters }: FilterProps) {
  const { t } = useTranslation()

  const opportunityTypeFilters = useMemo(() => {
    return [
      {
        label: t('workplace_giving.volunteering.filter.all'),
        value: undefined
      },
      {
        label: t('workplace_giving.volunteering.project'),
        value: OpportunityType.Project
      },
      {
        label: t('workplace_giving.volunteering.event'),
        value: OpportunityType.Event
      }
    ]
  }, [t])

  return (
    <Box>
      <Typography className={styles.FiltersSectionTitle}>{t('workplace_giving.volunteering.filters.type')}</Typography>
      <Flex gap="0.5rem">
        {opportunityTypeFilters.map(filter => (
          <Chip
            key={filter.label}
            testId={`opportunityTypeFilter-${filter.value}`}
            label={filter.label}
            classNames={styles.FiltersChip}
            disabled={selectedFilters.type === filter.value}
            handleClick={() => {
              setSelectedFilters({ ...selectedFilters, type: filter.value })
            }}
          />
        ))}
      </Flex>
    </Box>
  )
}
